import React, { useState } from "react";
import { FiX } from "react-icons/fi";
import Logo from "../../../assets/logoweb.png";
import api from "../../../utils/api";
import { Link } from "react-router-dom";

const ForgotPassword = ({ closeAllPopups }) => {
  const [email, setEmail] = useState(""); // State to store the user's email
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleContinue = async (e) => {
    e.preventDefault(); // Prevents form submission
    setLoading(true); // Show loading state
    setError(""); // Clear previous errors

    try {
      const response = await api.post("/auth/forgot-password", {
        email,
      });

      console.log("Response:", response.data);

      if (response?.data?.status === "success" && response?.data?.resetPasswordToken) {
        // Navigate to the reset password URL
        window.location.href = response.data.resetPasswordToken;
      } else {
        setError("Failed to retrieve reset link. Please try again.");
      }
    } catch (err) {
      setError(err.response?.data?.message || "Something went wrong. Please try again.");
    } finally {
      setLoading(false); // Hide loading state
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white w-[90%] md:w-[80%] mx-auto lg:w-[50%] rounded-lg shadow-lg relative">
        <button
          onClick={closeAllPopups}
          className="absolute top-3 right-6 bg-black rounded-full w-10 h-10 flex items-center justify-center text-xl text-white font-bold hover:text-gray-700"
        >
          <FiX />
        </button>

        <div className="p-8 max-h-[80vh] md:px-16 custom-scrollbar">
          <div className="flex items-center justify-center gap-2">
            <img src={Logo} alt="Logo" className="lg:w-[66px] lg:h-[65px] md:w-[55px] md:h-[55px] w-[45px] h-[45px]" />
            <h1 className="lg:text-[20px] font-semibold text-[14.39px] sm:text-[14.39px]">
              Levante Cuisine
            </h1>
          </div>

          <h2 className="text-center body lg:text-[28px] font-[700] mb-4 mt-5">
            Enter Your Email Address
          </h2>
          <p className="text-center text-[10.07px] sm:text-[10.07px] md:text-[12px] lg:text-[13px] text-gray-500 mb-6">
            Please enter your email address to reset your password.
          </p>
          {error && <p className="text-red-500 text-center mb-4">{error}</p>}
          <form onSubmit={handleContinue}>
            <div className="mb-4">
              <label
                htmlFor="resetEmail"
                className="block text-[14px] font-medium text-black body mb-2"
              >
                Email Address
              </label>
              <input
                id="resetEmail"
                type="email"
                placeholder="Enter your email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)} // Update state
                className="w-full p-3 border border-gray-300 rounded-md"
                required
              />
            </div>
            <button
              type="submit"
              className="w-full rounded-full bg-[#AF313D] text-white p-3 mb-4 text-[14.39px] sm:text-[14.39px] lg:text-[20px] font-baloo font-semibold"
              disabled={loading}
            >
              {loading ? "Processing..." : "Continue"}
            </button>
            <div className="flex gap-2 items-center justify-center">
              <h1 className="text-[#282A37] text-[14px]">Still need help?</h1>
          <Link to="/contact">
          <h2 className="text-[#156CD7] text-[14px]">Contact us</h2>
          </Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
